import React from "react";
import { connect } from "react-redux";
import {
  setSubscriptionTargetChargeValue,
  setSubscriptionTerm,
  setSubscriptionUserNum
} from "../redux/actions";
import { OnBlurInput } from "./OnBlurInput";
import { Form, FormControl, InputGroup } from "react-bootstrap";

function UniflowOptions(props) {
  return (
    <div>
      <Form.Label>Uniflow</Form.Label>

      <div className="form-group">
        <InputGroup>
          <InputGroup.Prepend>
            <InputGroup.Text>$</InputGroup.Text>
          </InputGroup.Prepend>
          <FormControl
            as={OnBlurInput}
            type="number"
            value={props.subscriptionTargetChargeValue}
            onConfirm={e =>
              props.setSubscriptionTargetChargeValue(e.target.value)
            }
          />
          <InputGroup.Append>
            <InputGroup.Text>per user</InputGroup.Text>
          </InputGroup.Append>
        </InputGroup>
      </div>

      <div className="form-group">
        <InputGroup>
          <InputGroup.Prepend>
            <InputGroup.Text>for</InputGroup.Text>
          </InputGroup.Prepend>
          <FormControl
            as={OnBlurInput}
            type="number"
            value={props.subscriptionUserNum}
            onConfirm={e => props.setSubscriptionUserNum(e.target.value)}
          />
          <InputGroup.Append>
            <InputGroup.Text>users per month</InputGroup.Text>
          </InputGroup.Append>
        </InputGroup>
      </div>

      <div className="form-group">
        <InputGroup>
          <InputGroup.Prepend>
            <InputGroup.Text>for</InputGroup.Text>
          </InputGroup.Prepend>
          <FormControl
            as="select"
            className="custom-select"
            value={props.subscriptionTerm}
            onChange={e => props.setSubscriptionTerm(Number(e.target.value))}
          >
            <option value="12">12</option>
            <option value="24">24</option>
            <option value="36">36</option>
            <option value="60">60</option>
          </FormControl>
          <InputGroup.Append>
            <InputGroup.Text>months</InputGroup.Text>
          </InputGroup.Append>
        </InputGroup>
      </div>
    </div>
  );
}

export default connect(
  ({ product }) => ({
    subscriptionTargetChargeValue: product.subscriptionTargetChargeValue,
    subscriptionUserNum: product.subscriptionUserNum,
    subscriptionTerm: product.subscriptionTerm
  }),
  {
    setSubscriptionTargetChargeValue,
    setSubscriptionTerm,
    setSubscriptionUserNum
  }
)(UniflowOptions);
